import { Badge } from '@/components/ui/badge';
import { StatementStatus } from '@/types';

const LABELS: Record<StatementStatus, string> = {
  pending: 'Pending review',
  approved: 'Approved, awaiting payout',
  paid: 'Paid',
  void: 'Void',
};

const VARIANTS: Record<StatementStatus, 'provisioning' | 'submitted' | 'active' | 'cancelled'> = {
  pending: 'provisioning',
  approved: 'submitted',
  paid: 'active',
  void: 'cancelled',
};

export function StatementStatusBadge({ status }: { status: StatementStatus }) {
  return <Badge variant={VARIANTS[status]}>{LABELS[status]}</Badge>;
}

function formatPeriodToken(token: string): string {
  const q = token.match(/^(\d{4})-Q([1-4])$/);
  if (q) return `Q${q[2]} ${q[1]}`;
  const m = token.match(/^(\d{4})-(\d{2})$/);
  if (m) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[Number(m[2]) - 1]} ${m[1]}`;
  }
  return token;
}

/** Labels are 'YYYY-MM', 'YYYY-Qn', 'YYYY-MM to YYYY-MM' (carry-over) or any of those with ' (partial)'. */
export function formatPeriodLabel(label: string): string {
  const partial = label.endsWith(' (partial)');
  const core = partial ? label.slice(0, -' (partial)'.length) : label;
  const formatted = core
    .split(' to ')
    .map((t) => formatPeriodToken(t.trim()))
    .join(' to ');
  return partial ? `${formatted} (partial)` : formatted;
}

export function describeEventBasis(e: { event_type: string; basis_amount: number | null; rate: number | null }, formatCurrency: (n: number) => string): string {
  if (e.event_type === 'per_account') return 'First paid invoice';
  if (e.basis_amount != null && e.rate != null) return `${formatCurrency(e.basis_amount)} billed × ${e.rate}%`;
  return 'Recurring billed';
}
